module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"weather_and_sales_comparison":"天気と売り上げの関係性","staffRankingTableTitle":"スタッフパフォーマンス・ランキング表","Rank":"ランキング","Name":"名前","Location":"店舗","TransactionSize":"取引金額","HoursWorked":"勤務時間","SCHEDULER":"シフト管理表","low":"低","high":"高"}}')
  delete Component.options._Ctor
}
